import { render, staticRenderFns } from "./IconNotice.vue?vue&type=template&id=27503f40&scoped=true&"
import script from "./IconNotice.vue?vue&type=script&lang=js&"
export * from "./IconNotice.vue?vue&type=script&lang=js&"
import style0 from "./IconNotice.vue?vue&type=style&index=0&id=27503f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27503f40",
  null
  
)

export default component.exports